import { FC, useState, useRef, useEffect } from "react";
import { scroller } from "react-scroll";
import Image from "next/image";

// Declare Vimeo type for TypeScript
declare global {
  interface Window {
    Vimeo: any;
  }
}

const RentToOwn: FC = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isOverlayFading, setIsOverlayFading] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const playerRef = useRef<any>(null);

  // Initialize Vimeo Player
  useEffect(() => {
    if (typeof window !== "undefined" && iframeRef.current) {
      // Add ID to iframe for Vimeo Player API
      iframeRef.current.id = "vimeo-iframe-1117395768";

      // Load Vimeo Player API script if not already loaded
      if (typeof window.Vimeo === "undefined") {
        const script = document.createElement("script");
        script.src = "https://player.vimeo.com/api/player.js";
        script.async = true;
        script.onload = () => {
          // Once script is loaded, initialize the player
          playerRef.current = new window.Vimeo.Player(iframeRef.current);
        };
        document.head.appendChild(script);
      } else {
        // Vimeo API already loaded, initialize player directly
        playerRef.current = new window.Vimeo.Player(iframeRef.current);
      }
    }

    // Cleanup
    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
      }
    };
  }, []);

  const handlePlayVideo = async () => {
    console.log("1");
    if (playerRef.current) {
      try {
        // Start fade-out transition
        console.log("2");
        setIsOverlayFading(true);

        // Wait for the fade-out transition to complete (0.5 seconds)
        setTimeout(async () => {
          await playerRef.current.play();
          setIsVideoPlaying(true);
        }, 500);
      } catch (error) {
        console.error("Error playing video:", error);
      }
    }
  };
  return (
    <div className="flex flex-col bg-landing-blue md:flex-row w-full pb-32 md:pb-auto py-8 md:py-16 text-white relative md:px-6 px-5 lg:px-11 xl:px-32 xl:pt-20 xl:pb-[4.25rem]">
      <div className="w-full md:w-1/2 lg:w-1/2 h-auto ">
        <h1>
          <span className="block mt-2 text-4xl xs:text-[44px] md:text-[56px] xl:text-[76px] xs:leading-[46px] md:leading-[59px] xl:leading-[80px] font-bold whitespace-nowrap text-white">
            How does
          </span>
          <span className="text-4xl xs:text-[44px] md:text-[56px] xl:text-[76px] xs:leading-[46px] md:leading-[59px] xl:leading-[80px] font-bold whitespace-nowrap  text-landing-orange">
            rent to own work?
          </span>
        </h1>
        <h2 className="text-landing-white font-serif text-xl max-w-xs xs:max-w-md md:max-w-none xl:text-2xl md:mt-4 xl:mt-7 md:leading-8 mt-7 md:w-[19.8rem] xl:w-[30.375rem] overflow-visible">
          Rent one of our homes and buy it later when you are ready
        </h2>
        <button
          onClick={() => scroller.scrollTo("1", { smooth: true, duration: 100 })}
          className="inline-block w-auto text-center mb-4 md:mb-0 px-4 py-3 mx-auto text-base font-bold text-landing-blue transition duration-300 ease-in-out transform rounded shadow mt-7 xl:mt-9 bg-landing-orange hover:scale-105 z-10 relative"
        >
          See how it works
        </button>
      </div>

      <div className="flex flex-col md:w-1/3 lg:w-1/4 lg:ml-[8%] flex-none">
        <div className="relative aspect-square w-full max-w-[400px] bg-gray-100 self-start min-h-[300px]">
          <div
            style={{
              position: "absolute",
              borderBottomWidth: 2,
              borderColor: "white",
              marginTop: "7%",
              width: "80%",
              marginLeft: "15%",
            }}
          />
          <div
            style={{
              position: "absolute",
              borderBottomWidth: 2,
              borderColor: "white",
              marginTop: "93%",
              width: "80%",
              marginLeft: "15%",
            }}
          />
          <div
            style={{
              position: "absolute",
              borderLeftWidth: 2,
              borderColor: "white",
              marginTop: "6%",
              height: "92%",
              marginLeft: "93%",
            }}
          />
          <div
            style={{
              position: "absolute",
              borderLeftWidth: 2,
              borderColor: "white",
              marginTop: "6%",
              height: "87%",
              marginLeft: "7%",
            }}
          />
          <div
            style={{
              position: "absolute",
              borderLeftWidth: 2,
              borderColor: "white",
              marginTop: "2%",
              height: "50%",
              marginLeft: "3%",
            }}
          />
          <div
            style={{
              position: "absolute",
              borderBottomWidth: 2,
              borderColor: "white",
              marginTop: "2%",
              width: "60%",
              marginLeft: "3%",
            }}
          />
          <div
            style={{
              position: "absolute",
              width: "80%",
              height: "80%",
              backgroundColor: "red",
              marginTop: "10%",
              marginLeft: "10%",
              minHeight: "240px",
            }}
          >
            <iframe
              ref={iframeRef}
              src="https://player.vimeo.com/video/1117395768?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              className="absolute w-[100%] h-[100%] top-0 left-0"
              title="Rent-to-own with Keyzy"
              suppressHydrationWarning
              loading="lazy"
            />

            {!isVideoPlaying && (
              <div
                className={`absolute w-[100%] h-[100%] bg-[#1279B3] flex items-center justify-center cursor-pointer transition-opacity duration-500 hover:bg-opacity-[99%] group ${
                  isOverlayFading ? "opacity-0" : "opacity-100"
                }`}
                onClick={handlePlayVideo}
              >
                <div className="text-center text-white">
                  <div className="w-full mt-8 flex justify-center">
                    <div className="w-[80%]">
                      <Image
                        src="/how-it-works/keyzy-logo-white.svg"
                        alt="Keyzy Logo"
                        width={400}
                        height={100}
                        className="w-full h-auto"
                      />
                    </div>
                  </div>
                  <div className="text-lg md:text-xl font-semibold mb-2 hover:cursor-pointer">
                    Watch video
                    <span className="text-lg ml-2 transition-all duration-300 group-hover:ml-4">
                      ▶
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Dog — always below the video frame */}
        <div className="hidden lg:block mt-2 w-full">
          <Image
            src="/how-it-works/desktop-dog.svg"
            alt="Dog"
            width={555}
            height={61}
            className="w-full h-auto"
          />
        </div>
        <div className="lg:hidden mt-4 w-full flex justify-center md:hidden">
          <Image
            src="/how-it-works/mobile-dog.svg"
            alt="Dog"
            width={332}
            height={45}
            className="w-full h-auto"
          />
        </div>
      </div>

      {/* Tablet decorations */}
      <div className="hidden md:block lg:hidden absolute bottom-4 right-0 w-auto mr-[5%]">
        <Image
          src="/how-it-works/tablet-dog.svg"
          alt="Dog"
          width={555}
          height={185}
          className="w-auto h-24"
        />
      </div>
      <div className="hidden md:block lg:hidden absolute right-0 mr-[9%] mt-[-2%]">
        <Image
          src="/how-it-works/tablet-red-ribbon.svg"
          alt="Tablet ribbon"
          width={60}
          height={70}
        />
      </div>
      <div className="hidden md:block lg:hidden absolute right-0 mr-[18%] mt-[1%] top-0">
        <Image
          src="/how-it-works/tablet-blue-ribbon.svg"
          alt="Tablet ribbon"
          width={60}
          height={70}
        />
      </div>
      <div className="hidden md:block lg:hidden absolute">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="69"
          viewBox="0 0 53 69"
          fill="none"
        >
          <path opacity="0.2" d="M52.8436 0H0.609375V68.1948H52.8436V0Z" fill="#0E79B2" />
        </svg>
      </div>

      {/* Desktop ribbon */}
      <div className="hidden lg:block relative top-0">
        <Image
          src="/how-it-works/laptop-ribbon.svg"
          alt="Ribbon"
          width={150}
          height={400}
          className="w-auto h-40"
          priority
        />
      </div>
    </div>
  );
};

export default RentToOwn;
